type Config = {
  apiUrl: string;
  /**
   * Demo-org Personal Access Token. Populated at build time only when we want
   * the /embed/* routes to render against the demo environment without a user
   * session (e.g. for live dashboard embeds on the DevAnalytics marketing page).
   * Leave unset in builds where a shared PAT in the bundle is not appropriate.
   */
  demoPat: string | undefined;
};

export const config: Config = {
  apiUrl: (process.env.PUBLIC_API_URL || 'http://localhost:8001').replace(/\/$/, ''),
  demoPat: process.env.PUBLIC_DEMO_PAT || undefined,
};
